import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Menu, MenuItem, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  anchorEl: any | null;
  menuOpen: boolean;
  exclude: boolean;

  handleExcludeChange(value: boolean): () => void;

  handleCloseMenu(): void;
}

const ConstraintMenu: React.FC<Props> = ({ anchorEl, exclude, menuOpen, handleExcludeChange, handleCloseMenu }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Menu
      classes={{ list: classes.menuList, paper: classes.menuPaper }}
      anchorEl={anchorEl}
      open={menuOpen}
      onClose={handleCloseMenu}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{ paper: { style: { width: 'auto' } } }}
      disableEnforceFocus={true}
      disableAutoFocus={true}
      disableAutoFocusItem={true}
      disableRestoreFocus={true}
    >
      <MenuItem
        className={classes.menuItem}
        disableRipple={true}
        selected={!exclude}
        onClick={() => {
          handleExcludeChange(false)();
          handleCloseMenu();
        }}
      >
        <Stack direction={'row'} alignItems={'center'} gap={1}>
          {!exclude ? <RadioButtonCheckedIcon className={classes.icon} /> : <RadioButtonUncheckedIcon className={classes.icon} />}
          <Typography className={classes.menuItemText}>{t('include')}</Typography>
        </Stack>
      </MenuItem>
      <MenuItem
        className={classes.menuItem}
        disableRipple={true}
        selected={exclude}
        onClick={() => {
          handleExcludeChange(true)();
          handleCloseMenu();
        }}
      >
        <Stack direction={'row'} alignItems={'center'} gap={1}>
          {exclude ? <RadioButtonCheckedIcon className={classes.icon} /> : <RadioButtonUncheckedIcon className={classes.icon} />}
          <Typography className={classes.menuItemText}>{t('exclude')}</Typography>
        </Stack>
      </MenuItem>
    </Menu>
  );
};

const useStyles = makeStyles()((theme) => ({
  menuPaper: {
    borderRadius: 0,
    maxHeight: '33vh',
    width: '100%',
    marginLeft: '8px',
  },
  menuList: {
    padding: 0,
  },
  menuItem: {
    fontSize: theme.typography.pxToRem(13),
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    padding: '6px 16px',
    '&.Mui-selected': {
      background: theme.palette.backgrounds.main,

      '&:hover, &:focus': {
        background: theme.palette.backgrounds.main,
      },
    },
    '&:last-of-type': {
      borderBottom: 'unset',
    },
    '&:hover': {
      background: theme.palette.backgrounds.main,
    },
    '&:focus': {
      background: '#FFF',
    },
  },
  menuItemText: {
    fontSize: theme.typography.pxToRem(13),
    '&.delete': {
      color: theme.palette.error.main,
    },
  },
  icon: {
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.primary.main,
  },
}));

export default ConstraintMenu;
